import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGoogle,
  faInstagram,
  faPinterest,
  faReddit,
  faSnapchat,
  faTiktok,
  faTumblr,
  faXTwitter,
  faYoutube,
  faThreads
} from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { Badge } from "@mui/material";

const PlatformIcon = ({
  platform = {},
  classes = {},
  styles = {},
  clickHandler = null,
  badge = false,
  testid = ""
}) => {
  const platformType = platform.type ? platform.type.toUpperCase() : null;

  let fontAwesomeIcon = null;
  switch (platformType) {
    case "FACEBOOK":
    case "FACEBOOK_ADS":
    case "FACEBOOK_GROUP":
      fontAwesomeIcon = faFacebookF;
      break;
    case "INSTAGRAM":
      fontAwesomeIcon = faInstagram;
      break;
    case "THREADS":
      fontAwesomeIcon = faThreads;
      break;
    case "TWITTER":
      fontAwesomeIcon = faXTwitter;
      break;
    case "LINKEDIN":
      fontAwesomeIcon = faLinkedinIn;
      break;
    case "YOUTUBE":
      fontAwesomeIcon = faYoutube;
      break;
    case "PINTEREST":
      fontAwesomeIcon = faPinterest;
      break;
    case "GMB":
      fontAwesomeIcon = faGoogle;
      break;
    case "TIKTOK":
      fontAwesomeIcon = faTiktok;
      break;
    case "REDDIT":
      fontAwesomeIcon = faReddit;
      break;
    case "SNAPCHAT":
      fontAwesomeIcon = faSnapchat;
      break;
    case "TUMBLR":
      fontAwesomeIcon = faTumblr;
      break;
    case "OTHER":
      fontAwesomeIcon = faPaperPlane;
      break;
    default:
      fontAwesomeIcon = faPaperPlane;
      break;
  }

  return (
    <i
      className={classes}
      aria-hidden="true"
      style={styles}
      onClick={clickHandler}
      data-testid={`${testid}-${platform.type}-icon`}
    >
      {badge ? (
        <Badge variant="dot" color="error">
          <FontAwesomeIcon icon={fontAwesomeIcon} />
        </Badge>
      ) : (
        <FontAwesomeIcon icon={fontAwesomeIcon} />
      )}
    </i>
  );
};

export default PlatformIcon;
